var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 45,
    height: 45,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 30.882,
    height: 30.882,
    transform: "translate(7.059 7.059)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Men",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 44,
    height: 44,
    rx: 12.5,
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#c19444",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M19.731,21.247a.452.452,0,0,0-.092.377,2.93,2.93,0,0,0,5.721,0,.452.452,0,0,0-.443-.544H20.082A.452.452,0,0,0,19.731,21.247Zm4.54.738a2.04,2.04,0,0,1-3.543,0Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M18.631,18.117a.454.454,0,0,0,.11-.014l.4-.1v.629a.452.452,0,0,0,.9,0v-.856l.624-.156a.452.452,0,1,0-.219-.878l-1.934.483a.452.452,0,0,0,.109.891Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M24.324,17.62l.624.156v.856a.452.452,0,0,0,.9,0V18l.4.1a.452.452,0,0,0,.219-.878l-1.934-.483a.452.452,0,0,0-.219.878Z",
    fill: "#c19444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M31.766,30.109l-3.578-1.651a2.909,2.909,0,0,0-1.367-1.424v-1.3q.169-.141.33-.295a6.679,6.679,0,0,0,2.088-4.876v-.515h.273a1.662,1.662,0,0,0,1.653-1.831,1.714,1.714,0,0,0-1.722-1.491h-.007a1,1,0,0,1-.968-.756l-.021-.083A3.346,3.346,0,0,0,24.8,13.374a16.1,16.1,0,0,1-6.518-.494.452.452,0,0,0-.569.324l-.692,2.769a1,1,0,0,1-.968.756h-.493a11.99,11.99,0,0,1-.506-1.779,5.226,5.226,0,0,1,.257-3.431,2.5,2.5,0,0,1,1.621-1.166A3.458,3.458,0,0,0,17,11.61a.452.452,0,0,0,.87-.248,2.474,2.474,0,0,1,.4-2.023c.685-.9,2.147-1.375,4.229-1.375a10.21,10.21,0,0,1,5.755,1.879A4.344,4.344,0,0,1,29.988,14.6l-.188.689a.452.452,0,1,0,.873.238l.188-.689a5.249,5.249,0,0,0-2.1-5.746A11.1,11.1,0,0,0,22.5,7.059c-2.419,0-4.087.587-4.959,1.745a3.1,3.1,0,0,0-.339.567,3.553,3.553,0,0,0-2.68,1.7c-1.114,1.935-.23,4.841.155,5.9a1.649,1.649,0,0,0,.812,3.087h.273v.337A7,7,0,0,0,17.6,25.132a6.91,6.91,0,0,0,.576.559v1.343a2.91,2.91,0,0,0-1.367,1.424l-3.578,1.651a4.818,4.818,0,0,0-2.791,4.362v3.018a.452.452,0,0,0,.9,0V34.471a3.911,3.911,0,0,1,2.265-3.54l2.92-1.348a7.942,7.942,0,0,0,1.218,4.254A.452.452,0,0,0,18.4,34L20.33,32.71l.255.51-.469,4.219a.452.452,0,0,0,.4.5l.05,0a.452.452,0,0,0,.449-.4l.439-3.949h2.091l.439,3.949a.452.452,0,0,0,.449.4l.05,0a.452.452,0,0,0,.4-.5l-.469-4.219.255-.51L26.6,34a.452.452,0,0,0,.648-.16,7.941,7.941,0,0,0,1.218-4.254l2.92,1.347a3.911,3.911,0,0,1,2.265,3.54v3.018a.452.452,0,0,0,.9,0V34.471A4.819,4.819,0,0,0,31.766,30.109Zm-15.1-9.721V19.6a.452.452,0,0,0-.452-.452h-.725a.756.756,0,0,1-.752-.836.8.8,0,0,1,.821-.677h.491a1.9,1.9,0,0,0,1.846-1.441l.579-2.317a17.16,17.16,0,0,0,6.434.4,2.441,2.441,0,0,1,2.66,1.837l.021.083a1.9,1.9,0,0,0,1.846,1.441h.007a.8.8,0,0,1,.821.677.757.757,0,0,1-.752.836h-.725a.452.452,0,0,0-.452.452v.967a5.833,5.833,0,0,1-6.116,5.826,5.7,5.7,0,0,1-3.946-1.872A6.1,6.1,0,0,1,16.667,20.388Zm1.649,12.577c-.856-1.708-1.1-3.11-.705-4.076a2,2,0,0,1,.935-1.03l1.239,1.084a.452.452,0,1,0,.6-.681l-1.3-1.134v-.779a6.523,6.523,0,0,0,3.091.946q.165.008.329.008a6.676,6.676,0,0,0,3.412-.927v.753L22.5,30.118l-.668-.585a.452.452,0,1,0-.6.681l.521.456Zm5.355-.281H21.329l-.24-.481,1.411-.941,1.411.941Zm3.013.281-3.441-2.294,3.212-2.81a2,2,0,0,1,.935,1.029C27.784,29.855,27.54,31.258,26.684,32.965Z",
    fill: "#c19444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentProfile);
export default __webpack_public_path__ + "static/media/student-profile.76c3f07262d8a0d2a26645b25207e1e6.svg";
export { ForwardRef as ReactComponent };